import { useSearchParams } from 'react-router-dom'
import Navbar from '../Component/Navbar'
import Sidebar from '../Component/Sidebar'
import { useUser } from '../UserContext'
import Tabs from '../Component/Tabs'
import { getAliasLeaguesUrl } from '../api/urls'
import { useApiGet } from '../api/apiHooks'
import Skeleton from 'react-loading-skeleton'
import CustomSelect from '../Component/CustomSelect'
import { useEffect, useState } from 'react'
import Matches from './Matches'
import Standings from './Standings'
import './fixtures.css'

// Generate last 4 seasons
const getSeasons = () => {
  const seasons = []
  const currentYear = new Date().getFullYear()
  for (let i = 0; i < 4; i++) {
    const start = currentYear - i
    const end = start + 1
    seasons.push({
      value: `${start}/${end}`,
      label: `${start}-${String(end).slice(-2)}`,
    })
  }
  return seasons
}

function FixturesIndex() {
  const { user } = useUser()
  const seasons = getSeasons()
  const [leagueId, setLeagueId] = useState(null) // by default "english p_league"
  // Initial state is the latest season
  const [seasonName, setSeasonName] = useState(seasons[0].value)

  // for tab
  const [searchParams, setSearchParams] = useSearchParams()
  const selectedTab = searchParams.get('tab') || 'matches'
  const tabsData = [
    { id: 1, label: 'Matches' },
    { id: 2, label: 'Standings' },
  ]
  const handleTabSelection = (newTab) => {
    setSearchParams({ tab: newTab.label.toLowerCase() })
  }

  // league
  const { isLoading: isLoadingLeagues, data: aliasLeagues } = useApiGet({
    queryKey: [getAliasLeaguesUrl()],
  })

  let sortedAliasLeagues = []
  if (aliasLeagues) {
    const excludedLeagues = [
      3412, // Club World Cup
      1326, // euro 24 test,
      1082, // International Friendly,
      2, // UEFA Champions League,
    ]
    sortedAliasLeagues = aliasLeagues
      .filter((league) => !excludedLeagues.includes(league.identity))
      .sort((a, b) => a.name.localeCompare(b.name))
  }

  const leagueOption =
    sortedAliasLeagues?.map((league) => ({
      label: league.name,
      value: league.id,
      imgSrc: league.logo,
    })) || []

  const handleLeagueChange = (selectedOption) => {
    setLeagueId(selectedOption.value)
  }

  // Set default league to English Premier League (identity: 8) on initial load
  useEffect(() => {
    let defaultLeague = aliasLeagues?.find((l) => l.identity === 8) // English Premier League
    setLeagueId(defaultLeague?.id)
  }, [aliasLeagues])

  return (
    <div className='LoggedInContainer'>
      <Navbar />
      {user.token ? <Sidebar /> : ''}

      <div
        className={user.token ? 'mainContent' : ''}
        style={{ paddingInline: 'clamp(10px, 3vw, 30px)', paddingTop: 30 }}
      >
        {/* main content starts from here ====================================== */}
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          {isLoadingLeagues ? (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Skeleton width={250} height={50} />
            </div>
          ) : (
            <CustomSelect
              options={leagueOption}
              onChange={handleLeagueChange}
              selectedOption={leagueOption.find(
                (opt) => opt.value === leagueId
              )}
            />
          )}

          {/* filter row */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              marginBottom: 10,
            }}
          >
            {/* tabs selector */}
            <div>
              <Tabs
                tabsData={tabsData}
                selectedTab={selectedTab}
                handleTabSelection={handleTabSelection}
              />
            </div>

            {/* season selection */}
            <div>
              <select
                name='season'
                className='SelectBox'
                onChange={(e) => setSeasonName(e.target.value)}
                value={seasonName}
              >
                {seasons.map((season) => (
                  <option key={season.value} value={season.value}>
                    {season.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {leagueId && selectedTab === 'matches' && (
            <Matches leagueIdOrIdentity={leagueId} seasonName={seasonName} />
          )}

          {leagueId && selectedTab === 'standings' && (
            <Standings leagueIdOrIdentity={leagueId} seasonName={seasonName} />
          )}
        </div>
        {/* main content end ====================================== */}
      </div>
    </div>
  )
}

export default FixturesIndex
